import {
  BaSeHeading4,
  BaSeParagraph,
  BaSePopupButton,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { FormContext } from '../../hook/form-context';
import RegisterInterest from './register-interest';
import {
  BoxItem,
  ContentPagination,
  ContentSelectClass,
  GridItems,
} from './style';

function ListClasses({
  selectedUfOption,
  classes,
  totalItems,
  pageIndex,
  totalPages,
  selectedIdClass,
  handleSelectClass,
  handlePageChange,
}) {
  const { setSelectCityIdForClass, setNameClass, loadingClasses } =
    React.useContext(FormContext);

  const returnNumberFormated = React.useCallback((num) => {
    const numberFormated = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    return numberFormated.format(num);
  }, []);

  // lista dde classes
  const renderClasses = () => (
    <GridItems>
      {classes.map((item) => (
        <BoxItem
          key={item.idClassRoom}
          selected={selectedIdClass === item.idClassRoom}
          onClick={() => {
            handleSelectClass(item.idClassRoom);
            setSelectCityIdForClass(item.cityId);
            setNameClass(item.city);
          }}
        >
          <BaSeParagraph>{item.city}</BaSeParagraph>
          <BaSeParagraph>{returnNumberFormated(item.value)}</BaSeParagraph>
          <BaSeParagraph>{item.period}</BaSeParagraph>
        </BoxItem>
      ))}
    </GridItems>
  );

  // paginacao
  const renderPagination = () => (
    <ContentPagination>
      <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
        Mostrando {classes.length} de {totalItems}
      </BaSeParagraph>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
          Página
        </BaSeParagraph>
        <select value={pageIndex + 1} onChange={handlePageChange}>
          {Array.from({ length: totalPages }, (_, i) => (
            <option key={i} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </select>
        <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
          de {totalPages}
        </BaSeParagraph>
      </div>
    </ContentPagination>
  );

  if (
    !JSON.parse(selectedUfOption)?.id ||
    (loadingClasses && classes.length === 0)
  ) {
    return null;
  }

  return (
    <ContentSelectClass>
      {classes.length > 0 ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: 8,
            }}
          >
            <BaSeHeading4 color={BaSeTheme.colors.defaultColors.white}>
              Selecione o valor* e período do seminário
            </BaSeHeading4>
            <BaSePopupButton
              alertSize={300}
              name="exclamation-circle"
              iconProps={{
                color: '#fff',
                name: 'exclamation-circle',
                size: 15,
              }}
              message="Os valores apresentados podem variar conforme os custos operacionais oferecidos no seminário em cada localidade."
              title="exclamation-circle"
            />
          </div>

          {renderClasses()}
          {renderPagination()}
          <RegisterInterest type="otherPeriod" />
        </div>
      ) : (
        <RegisterInterest type="noClasses" />
      )}
    </ContentSelectClass>
  );
}

export default ListClasses;
